/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

const generateSubscribeParams = (generateUniqueKey?: boolean) => {
  const params: { [key: string]: any } = {
    // Instead of using Tooling's MINOR_API_VERSION env var,
    // use the latest and greatest version of the integration.
    // By supplying the today date, we allow the Integrations
    // server to fall back to the most recent supported version.
    version: new Date().toISOString().slice(0, 10) // formats to "YYYY-MM-DD"
  };

  if (generateUniqueKey === true) {
    // If true, the API will generate a unique public/private key pair.
    params.generate_encryption_key = true;
  }
  return params;
};

export { generateSubscribeParams };
